export default __webpack_public_path__ + "static/media/invest-monitor.0ca8d49d.svg";